<!-- =========================================================================================
  File Name: Profile.vue
  Description: Profile Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="profile-page">

    <!-- PROFILE HEADER -->
    <div class="profile-header max-w-xs3 sm:max-w-full mx-auto">
      <div class="relative">
        <div class="cover-container rounded-t-lg">
          <img :src="user_info.cover_img" alt="user-profile-cover" class="responsive block" style="max-height: 450px; object-fit: cover;">
        </div>
        <div class="profile-img-container">
          <div>
            <vx-tooltip position="bottom" text="Haga clic en la imagen para cambiarla">
              <vs-avatar class="user-profile-img cursor-pointer" :src="userImage" size="85px"/>
            </vx-tooltip>
          </div>
          <div class="profile-actions pointer-events-auto flex">
            <vx-tooltip position="bottom" text="Cambiar imagen de fondo">
              <vs-button icon-pack="feather" radius icon="icon-edit-2"></vs-button>
            </vx-tooltip>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-end flex-wrap profile-header-nav">

        <div class="block sm:hidden">
          <feather-icon @click="isNavOpen = !isNavOpen" icon="AlignJustifyIcon" v-show="!isNavOpen" class="vx-navbar-toggler cursor-pointer"/>
          <feather-icon icon="XIcon" v-show="isNavOpen" @click="isNavOpen = !isNavOpen" class="vx-navbar-toggler cursor-pointer"/>
        </div>
        <div :class="isNavOpen ? 'block': 'hidden'" class="w-full flex-grow sm:flex sm:items-center sm:w-auto">
          <div class="text-sm sm:flex-grow">
            <!--                        <ul class="sm:flex justify-start mt-8 w-full md:mt-0 md:ml-auto md:w-3/4">-->
            <!--                            <li class="p-2 sm:p-0 mr-4"><vs-button type="line" icon-pack="feather" icon="icon-user">Información</vs-button></li>-->
            <!--                            <li class="p-2 sm:p-0"><vs-button type="line" icon-pack="feather" icon="icon-shopping-cart">Órdenes</vs-button></li>-->
            <!--                        </ul>-->
            <vs-tabs alignment="center" v-model="activeTab">
              <vs-tab label="Información" icon-pack="feather" icon="icon-user" class="bg-grey-100">

                <!-- COL AREA -->
                <div class="vx-row">
                  <!-- COL 1 -->
                  <vs-spacer/>

                  <!-- COL 2 -->
                  <div class="vx-col w-full lg:w-1/2">
                    <vx-card class="mt-base bg-grey-700">
                      <vs-input class="w-full mt-8" label-placeholder="Nombre" icon-pack="feather" icon="icon-user" v-model="data.displayName"/>
                      <div class="w-full mt-2">
                        <span class="ml-8" style="font-size: .7rem; padding-left: .5rem!important; margin: 0; color: rgba(0,0,0,.4);">Fecha de nacimiento</span>
                        <datepicker class="mt-1" placeholder="Seleccione su fecha de nacimiento" v-model="data.birthdate" format="dd MMMM yyyy" :language="languages['es']"></datepicker>
                      </div>
                      <div class="w-full mt-2">
                        <span class="ml-8" style="font-size: .7rem; padding-left: .5rem!important; margin: 0; color: rgba(0,0,0,.4);">Sexo</span>
                        <ul class="flex justify-start">
                          <li>
                            <vs-radio class="mr-3" v-model="data.gender" vs-value="M">Masculino</vs-radio>
                          </li>
                          <li>
                            <vs-radio class="mr-3" v-model="data.gender" vs-value="F">Femenino</vs-radio>
                          </li>
                        </ul>
                      </div>
                      <vs-input class="w-full mt-8" label-placeholder="Correo electrónico" icon-pack="feather" icon="icon-mail" type="email" v-model="data.email" readonly="1"/>
                      <!--                      <vs-input class="w-full mt-8" label-placeholder="Número de teléfono" icon-pack="feather" icon="icon-phone" v-model="data.phone" readonly="1" @click="phoneValidationActive = true"/>-->
                      <vs-input class="w-full mt-8" label-placeholder="Número de teléfono" icon-pack="feather" icon="icon-phone" v-model="data.phone"/>
                      <!--
                                            <vs-input class="w-full mt-8" label-placeholder="Facebook" icon-pack="feather" icon="icon-facebook" v-model="data.facebook"/>
                                            <vs-input class="w-full mt-8" label-placeholder="Twitter" icon-pack="feather" icon="icon-twitter" v-model="data.twitter"/>
                                            <vs-input class="w-full mt-8" label-placeholder="Instagram" icon-pack="feather" icon="icon-instagram" v-model="data.instagram"/>
                      -->
                      <div class="flex w-full justify-between mt-8 mb-4" v-if="data.phone != ''">
                        <vs-button type="gradient" icon-pack="feather" icon="icon-save" @click="save">Guardar</vs-button>
                        <vs-spacer/>
                        <vs-button icon-pack="feather" icon="icon-shopping-bag" :to="{ name: 'category', params: { category: '1' } }" v-if="original_data.phone != ''" class="mr-2">Continuar comprando</vs-button>
                        <vs-button icon-pack="feather" icon="icon-shopping-cart" :to="{ name: 'checkout' }" v-if="hasItemsInCart && original_data.phone != ''">Ver carrito</vs-button>
                      </div>
                      <!--                      <phone-validation-view :isPhoneValidationActive="phoneValidationActive" :currentPhone="data.phone" @closePhoneValidation="phoneValidationActive = false"/>-->
                    </vx-card>
                  </div>

                  <vs-spacer/>
                </div>
              </vs-tab>
              <vs-tab label="Direcciones" icon-pack="feather" icon="icon-map-pin">
                <address-view :isAddressActive="addressWindowActive" :email="data.email" :id="addressId" :currentAddress="currentAddress" @closeAddress="closeAddress"/>
                <vx-card class="mt-base">
                  <vs-table v-if="windowWidth >= 768" notSpacer stripe noDataText="No se encontratron direcciones" :data="addresses">
                    <template slot="header">
                      <vs-button class="mb-4" size="small" icon-pack="feather" icon="icon-plus" @click="openAddress">Agregar dirección</vs-button>
                    </template>
                    <template slot="thead">
                      <vs-th>Nombre</vs-th>
                      <vs-th>Dirección</vs-th>
                      <vs-th>Municipio</vs-th>
                      <vs-th>Instrucciones</vs-th>
                      <vs-th></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].name">
                          <span>{{ data[indextr].name }}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].address">
                          <span>{{ data[indextr].address }}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].cityName">
                          {{ data[indextr].cityName }}, {{ data[indextr].stateName }}
                        </vs-td>
                        <vs-td :data="data[indextr].deliveryInstructions">
                          {{ data[indextr].deliveryInstructions }}
                        </vs-td>
                        <vs-td>
                          <div class="flex flex-row w-full items-center justify-center">
                            <vx-tooltip position="top" text="Modificar dirección" class="ml-3">
                              <vs-button radius icon-pack="feather" icon="icon-edit-2" color="warning" size="small" @click="editAddress(data[indextr])"/>
                            </vx-tooltip>
                            <vx-tooltip position="top" text="Eliminar dirección" class="ml-3">
                              <vs-button radius icon-pack="feather" icon="icon-x" color="danger" size="small" @click="confirmRemoveAddress(data[indextr])"/>
                            </vx-tooltip>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <vs-table v-else notSpacer stripe noDataText="No se encontratron direcciones" :data="addresses">
                    <template slot="header">
                      <vs-button class="mb-4" size="small" icon-pack="feather" icon="icon-plus" @click="openAddress">Agregar dirección</vs-button>
                    </template>
                    <template slot="thead">
                      <vs-th>Dirección</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].address">
                          <span><b>{{ data[indextr].name }}</b>: {{ data[indextr].address }}</span>
                        </vs-td>
                        <template slot="expand">
                          <div class="w-full md:hidden">
                            <span v-if="data[indextr].cityName">{{ data[indextr].cityName }}<br/></span>
                            <span v-if="data[indextr].stateName">{{ data[indextr].stateName }}<br/></span>
                            <span v-if="data[indextr].deliveryInstructions">{{ data[indextr].deliveryInstructions }}<br/></span>
                            <div class="flex flex-row w-full items-center justify-start mt-2">
                                <vs-button radius icon-pack="feather" icon="icon-edit-2" color="warning" size="small" @click="editAddress(data[indextr])" class="mr-6"/>
                                <vs-button radius icon-pack="feather" icon="icon-x" color="danger" size="small" @click="confirmRemoveAddress(data[indextr])"/>
                            </div>
                          </div>
                        </template>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </vs-tab>
              <vs-tab label="Órdenes" icon-pack="feather" icon="icon-shopping-cart">
                <vx-card class="mt-base">
                  <vs-table notSpacer stripe noDataText="No se encontraron órdenes" max-items="5" pagination :data="orders">
                    <template slot="header">
                      <h4>&nbsp;</h4>
                    </template>
                    <template slot="thead">
                      <vs-th>Fecha</vs-th>
                      <vs-th># Pedido</vs-th>
                      <vs-th>Dirección</vs-th>
                      <vs-th>Valor</vs-th>
                      <vs-th>Estado</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].date">
                          {{ formatTimestamp(data[indextr].date) }}
                        </vs-td>
                        <vs-td :data="data[indextr].orderNumber">
                          {{ data[indextr].c3Id }}
                        </vs-td>
                        <vs-td :data="data[indextr].address.address">
                          <span style="font-size: 10px;">
                            {{ data[indextr].address.address }}<br/>
                            {{ data[indextr].address.cityName }}<br/>
                            {{ data[indextr].address.stateName }}
                          </span>
                        </vs-td>
                        <vs-td :data="data[indextr].orderTotal">
                          Q{{ data[indextr].orderTotal.toFixed(2) }}
                        </vs-td>
                        <vs-td :data="data[indextr].status">
                          {{ data[indextr].status }}
                        </vs-td>
                        <template slot="expand">
                          <div class="w-full">
                            <vs-table notSpacer stripe noDataText="No se encontraron productos" :data="getProductsOrder(data[indextr])">
                              <template slot="thead">
                                <vs-th>Descripción</vs-th>
                                <vs-th>Cantidad</vs-th>
                                <vs-th>Precio</vs-th>
                                <vs-th>Valor</vs-th>
                              </template>
                              <template slot-scope="{data}">
                                <vs-tr :data="trp" :key="indextrp" v-for="(trp, indextrp) in data">
                                  <vs-td :data="data[indextrp].description">
                                    <span style="font-size: 10px;">{{ data[indextrp].description }}</span>
                                  </vs-td>
                                  <vs-td :data="data[indextrp].quantity">
                                    {{ data[indextrp].quantity }}
                                  </vs-td>
                                  <vs-td :data="data[indextrp].price">
                                    Q{{ data[indextrp].price.toFixed(2) }}
                                  </vs-td>
                                  <vs-td :data="data[indextrp].amount">
                                    Q{{ data[indextrp].amount.toFixed(2) }}
                                  </vs-td>
                                </vs-tr>
                              </template>
                            </vs-table>
                          </div>
                        </template>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
      <!-- <vx-navbar> -->
      <!-- </vx-navbar> -->
    </div>
  </div>
</template>

<script>
  import {db} from '@/firebaseConfig'
  import Datepicker from 'vuejs-datepicker';
  import * as lang from 'vuejs-datepicker/src/locale';

  export default {
    components: {
      Datepicker,
      AddressView: () => import('../components/Address'),
      // PhoneValidationView: () => import('../components/PhoneValidation')
    },
    data() {
      return {
        languages: lang,
        isNavOpen: false,
        original_data: {
          id: 0,
          name: '',
          phone: ''
        },
        data: {
          id: 0,
          name: '',
          phone: ''
        },
        activeTab: 0,
        addressWindowActive: false,
        phoneValidationActive: false,
        user_info: {
          profile_img: require('@/assets/images/portrait/small/MaleAvatar.png'),
          cover_img: require('@/assets/images/profile/store1.jpg')
        },
        wasSidebarOpen: null,
        addressToRemove: null,
        addressId: 0,
        currentAddress: null
      }
    },
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      activeUserInfo() {
        return this.$store.state.AppActiveUser;
      },
      userImage() {
        if (!this.$store.state.AppActiveUser.image) {
          if (this.$store.state.AppActiveUser.gender == 'F') {
            return require("@/assets/images/portrait/small/FemaleAvatar.png");
          } else {
            return require("@/assets/images/portrait/small/MaleAvatar.png");
          }
        }
      },
      hasItemsInCart() {
        return this.$store.state.eCommerce.cartItems.length > 0;
      },
      mediaType() {
        return (media) => {
          if (media.img) {
            const ext = media.img.split('.').pop()
            if (this.mediaExtensions.img.includes(ext)) return 'image'
          } else if (media.sources && media.poster) {
            // other validations
            return 'video'
          }
        }
      },
      playerOptions() {
        return (media) => {
          return {
            height: '360',
            fluid: true,
            autoplay: false,
            muted: true,
            language: 'en',
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            sources: media.sources,
            poster: media.poster
          }
        }
      },
      addresses() {
        if (this.data.hasOwnProperty('addresses')) {
          return this.data.addresses;
        } else {
          return [];
        }
      },
      orders() {
        return this.$store.state.orders;
      }
    },
    methods: {
      formatTimestamp(time) {
        return time.toDate().toLocaleString();
      },
      getProductsOrder(data) {
        return data.products;
      },
      openAddress() {
        this.addressId = Math.max.apply(Math, this.addresses.map(function(o) { return o.id; })) + 1;
        this.currentAddress = null;
        this.addressWindowActive = true;
      },
      closeAddress() {
        const self = this;
        setTimeout(() => {
          self.activeTab = 0;
        }, 300);
        setTimeout(() => {
          self.activeTab = 1;
        }, 600);
        this.addressWindowActive = false;
      },
      activatePhoneValidation() {
        this.phoneValidationActive = true;
      },
      loadContent() {
        var self = this;
        db.collection('users').doc(this.activeUserInfo.email).get()
          .then(function (doc) {
            if (doc.exists) {
              self.original_data = {...doc.data()};
              self.data = {...doc.data()};
              if (typeof self.data.birthdate == 'undefined') {
                self.data.birthdate = new Date();
              } else {
                self.data.birthdate = self.data.birthdate.toDate();
              }
              if (!self.data.hasOwnProperty('phone')) {
                self.data.phone = '';
              }
              if (!self.original_data.hasOwnProperty('phone')) {
                self.original_data.phone = '';
              }
              self.$store.dispatch('updateUserInfo', self.data);
            } else {
              db.collection('users').doc(self.activeUserInfo.email).set(self.activeUserInfo)
                .then(() => {
                  self.data = {...self.activeUserInfo};
                })
                .catch((error) => {
                  this.$vs.notify({
                    title: 'Error actualizando usuario',
                    text: error.message,
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    time: 8000
                  });
                })
            }
          })
          .catch((error) => {
            this.$vs.notify({
              title: 'Error actualizando usuario',
              text: error.message,
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              time: 8000
            });
            self.$router.push('/');
          });
      },
      save() {
        var self = this;
        if (this.data.email != '') {
          db.collection('users').doc(this.data.email).update(this.data)
            .then(() => {
              self.$store.dispatch('updateUserInfo', self.data);
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Los datos de su usuario fueron actualizados correctamente',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-info'
              });
            })
            .catch((error) => {
              self.$vs.notify({
                title: 'Error al actualizar usuario',
                text: error,
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              });
            })
        }
      },
      confirmRemoveAddress(address) {
        this.addressToRemove = address;
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Confirme eliminación',
          text: `Se procederá a eliminar la dirección ${address.address}, ${address.cityName}, ${address.stateName}`,
          buttonCancel: 'flat',
          acceptText: 'Aceptar',
          cancelText: 'Cancelar',
          accept: this.removeAddress
        });
      },
      removeAddress() {
        if (this.addressToRemove != null) {
          const self = this;
          const addresses = this.data.addresses.filter(item => item.id != this.addressToRemove.id);
          db.collection('users').doc(this.activeUserInfo.email).update({addresses: addresses})
            .then(() => {
              self.loadContent();
            })
            .catch((error) => {
              this.$vs.notify({
                title: 'Error actualizando direcciones de usuario',
                text: error.message,
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                time: 8000
              });
            })
        }
      },
      editAddress(address) {
        this.addressId = address.id;
        this.currentAddress = address;
        this.addressWindowActive = true;
      }
    },
    mounted() {
      this.wasSidebarOpen = this.$store.state.reduceButton;
      this.$store.commit('TOGGLE_REDUCE_BUTTON', true);
      this.loadContent();
    },
    beforeDestroy() {
      if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
    }
  }

</script>


<style lang="scss">
  @import "@/assets/scss/vuexy/pages/profile.scss";
</style>
